import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';

import { Image, ImageLoadState } from '@fluentui/react/lib/Image';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Loading } from '@bingads-webui-campaign-react/smart-component-primitive';


const getStyles = () => ({
  img: {
    '& img': {
      maxWidth: '100%',
    },
  },
  loading: {
    position: 'absolute',
    top: 0,
  },
});

const UnstyledSmartImageView = (props) => {
  const {
    src,
    classes,
    className,
    showLoading,
    ...rest
  } = props;
  const [isLoading, setIsLoading] = useState(showLoading);

  const onLoadingStateChange = (state) => {
    if (state === ImageLoadState.loaded) {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Image
        className={classnames(classes.img, className)}
        onLoadingStateChange={showLoading ? onLoadingStateChange : _.noop}
        src={src}
        alt=""
        {...rest}
      />
      {
        isLoading && <Loading className={classes.loading} />
      }
    </React.Fragment>
  );
};

UnstyledSmartImageView.propTypes = {
  src: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    img: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  showLoading: PropTypes.bool,
};

UnstyledSmartImageView.defaultProps = {
  className: undefined,
  showLoading: false,
};

UnstyledSmartImageView.displayName = 'SmartImageView';

export const SmartImageView = withDefaultStyles(UnstyledSmartImageView, getStyles);
